import * as angular from 'angular';
import * as _ from 'underscore';
import { IPromise } from 'angular';
import { IBrand, BrandsService, IBrandAnchor } from '../../brands.service';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';

class BrandsSelectorComponent {
    static $inject = ['$q', '$uibModal', 'brandsService', 'notificationService', '$translate'];

    allowAdd: boolean;
    categoryId: number | number[];
    searchAllBrands: boolean;
    model: IBrand[];
    singleSelect: boolean;
    onChange: () => void;

    all: IBrand[] = []; // all approved brands for specified categories
    available: IBrand[] = []; // all brands expect already selected
    pending: IBrand[] = []; // all pending brands for neighboring categories  by current live category
    filtered: IBrand[] = []; // available brands with search applied
    top: IBrand[] = []; // top filtered brands
    brandStatus = this.brandsService.statuses;
    htmlTooltip = {
        awaitingApproval: this.$translate.instant('this_brand_is_waiting_approval'),
        rejected: this.$translate.instant('this_brand_was_rejected'),
        unknown: this.$translate.instant('brand.unknow')
    };
    newBrand: string = null;
    errorBrand: string = null;

    private allApprovedBrands: IBrand[] = [];
    private brandsForSearch: IBrand[] = [];
    private topCount = 10;
    constructor(
        private $q: ng.IQService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private brandsService: BrandsService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService
    ) { }

    $onInit = async () => {
        try {
            this.allApprovedBrands = await this.brandsService.getApprovedBrands();
            this.setBrandsForSearch();
            this.refreshFiltered();
        } catch (error) {
            console.warn(error);
        }
    }

    $onChanges(changes: any) {
        if (changes.categoryId && (changes.categoryId.previousValue !== changes.categoryId.currentValue)) {
            this.updateData();
        }
    }

    refreshFiltered(search?: string) {
        // _.forEach($scope.available, function (brand) { brand.last = false; });
        let keywords = search || null;
        let offeredBrands = [];
        if (keywords && keywords.length > 0) {
            let reg = new RegExp('^.*' + keywords + '.*', 'i');
            this.filtered = _.filter(this.available, (brand) => {
                return reg.test(brand.Name);
            });
            let countMissing = this.topCount - this.filtered.length;
            if (countMissing > 0) {
                for (let c = 0; c < this.brandsForSearch.length; c++) {
                    if (reg.test(this.brandsForSearch[c].Name) && !_.any(this.model, (brand2) => {
                        return this.brandsForSearch[c].ID === brand2.ID;
                    })) {
                        let brand = angular.copy(this.brandsForSearch[c]);
                        brand.Status = this.brandStatus.pending;
                        offeredBrands.push(brand);
                    }
                    if (offeredBrands.length === countMissing) {
                        break;
                    }
                }
            }

        } else {
            this.filtered = this.available;
        }

        this.top = _.first(_.sortBy(_.union(this.filtered, offeredBrands), 'Name'), this.topCount);
        if (!_.isArray(this.top)) {
            this.top = [];
        }
        _.forEach(this.available, (brand) => { brand.last = false; });

        if (this.top.length > 0) {
            let last = _.last(this.top);
            last.last = true;
        }
        let alreadyexists = [];
        Array.prototype.push.apply(alreadyexists, this.model);
        Array.prototype.push.apply(alreadyexists, this.top);

        if ((keywords) && _.any(alreadyexists, (brand) => { return brand.Name.toLowerCase() === keywords.toLowerCase(); })) {
            this.newBrand = '';
        } else {
            this.newBrand = keywords;
        }

        if (this.validateBrandName()) {
            this.top.push({ Name: '', forApproval: true });
        }
    }

    getFilteredPlaceholder(): string {
        if (this.filtered.length) {
            return this.$translate.instant('search_to_add_a_brand');
        }
        return this.$translate.instant('add_brand');
    }

    delete(brand: IBrand) {
        this.model = _.reject(this.model, (mb) => {
            return mb === brand;
        });
        this.onChange();
        this.refreshAvailable();
    }

    onSelect(brand: IBrand) {
        if (brand.forApproval) {
            return;
        }
        if (_.all(this.model, (mb) => {
            return mb.ID !== brand.ID;
        })) {
            if (this.singleSelect) {
                this.model = [brand];
            } else {
                this.model.push(brand);
            }
        }
        this.onChange();
        this.refreshAvailable();
    }

    onSelectAll() {
        var flag = false;
        _.forEach(this.all, (brand) => {
            if (!_.any(this.model, (mb) => {
                return mb.ID === brand.ID;
            })) {
                this.model.push(brand);
                flag = true;
            }
        });
        if (flag) {
            this.onChange();
            this.refreshAvailable();
        }
    }

    onClearSelected() {
        this.model = [];
        this.onChange();
        this.refreshAvailable();
    }

    addNew() {
        if (this.validateBrandName()) {
            if (this.singleSelect) {
                this.model = [];
            }
            this.model.push({
                ID: null,
                Name: this.newBrand,
                Status: this.brandStatus.pending
            });
            this.onChange();
        } else {
            this.notificationService.showErrorMessage({
                body: this.errorBrand
            });
        }
    }

    showModalBrands = async ($event: Event) => {

        let brands = angular.copy(this.all);
        Array.prototype.push.apply(brands, angular.copy(this.pending));
        let selectedsAbsent: IBrand[] = [];
        _.forEach(this.model, (brand) => {
            if (brand.Status !== this.brandStatus.rejected && _.all(<IBrand[]>brands, (cb) => {
                return cb.ID !== brand.ID;
            })) {
                selectedsAbsent.push(brand);
            }
        });

        Array.prototype.push.apply(brands, selectedsAbsent);
        let brandAnchors = this.brandsService.getBrandAnchors();
        _.forEach(brands, (brand: IBrand) => {
            let char = brand.Name.trim()[0];
            brand.anchor = brandAnchors.regWord.test(char) ? char.toUpperCase() : brandAnchors.char;
            brand.selected = _.any(this.model, (cb: IBrand) => {
                return cb.ID === brand.ID;
            });
        });

        let anchors = angular.copy(brandAnchors.anchors);
        let groups = _.groupBy(brands, 'anchor'); // $filter('groupBy')(scope.brands, 'anchor');
        let keys = _.keys(groups);
        keys = keys.sort();
        _.forEach(anchors, (anchor: IBrandAnchor) => {
            anchor.disabled = !_.any(keys, (key) => {
                return key === anchor.value;
            });
            anchor.selected = false;
        });

        let startAnchor = _.findWhere(anchors, { value: keys[0] });
        let anchorNoChar = brandAnchors.char;

        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        try {
            let selectedBrands = await <IPromise<IBrand[]>>this.$uibModal.open({
                component: 'choiceBrands',
                resolve: {
                    brandStatus: () => this.brandStatus,
                    htmlTooltip: () => this.htmlTooltip,
                    brands: () => groups,
                    anchors: () => anchors,
                    startAnchor: () => startAnchor,
                    anchorNoChar: () => anchorNoChar,
                    singleSelect: () => this.singleSelect
                },
                size: 'lg',
                windowClass: 'wrapBrandsPopup'
            }).result;

            _.forEach(selectedBrands, (brand) => {
                if (_.all(this.model, (mb) => {
                    return mb.ID !== brand.ID;
                })) {
                    this.onSelect(brand);
                }
            });

            _.forEach(this.model, (mb) => {
                if (!_.any(selectedBrands, (brand) => { return mb.ID === brand.ID; })) {
                    this.delete(mb);
                }
            });
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClick(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }


    private updateData = async () => {
        let cID = _.isArray(this.categoryId) ? this.categoryId : [this.categoryId];
        let id = _.first(cID);
        let call = [this.brandsService.getByClassificationCategoryID(cID), this.$q.when([])];

        let result = await this.$q.all(call);
        this.all = result[0];
        this.pending = _.reject(result[1], (pending) => {
            return _.any(this.all, (approved) => { return pending.ID === approved.ID; });
        });
        this.setBrandsForSearch();
        this.refreshAvailable();
    }

    private setBrandsForSearch() {
        this.brandsForSearch = _.reject(this.allApprovedBrands, (brand1) => {
            return _.any(this.all, (brand2) => {
                return brand1.ID === brand2.ID;
            });
        });
    }

    private validateBrandName() {
        this.errorBrand = null;
        if (!this.newBrand) {
            return null;
        }
        this.newBrand = this.newBrand.trim();
        if (this.newBrand.length > 100) {
            this.errorBrand = 'Brand name must be less than 100 characters';
        } else if (this.newBrand.length < 2) {
            this.errorBrand = 'Brand name must be at least 2 characters long';
        } else if (_.any(this.model, (brand) => { return brand.Name.toLowerCase() === this.newBrand.toLowerCase(); })) {
            this.errorBrand = 'Brand name is already selected';
        }

        return this.errorBrand == null;
    }

    private refreshAvailable() {
        this.available = _.reject(this.all, (brand1) => {
            return _.any(this.model, (brand2) => {
                return brand1.ID === brand2.ID;
            });
        });
        this.refreshFiltered();
    }
}

angular.module('naut').component('brandsSelector', {
    template: require('./brandsSelector.html'),
    controller: BrandsSelectorComponent,
    controllerAs: '$ctrl',
    bindings: {
        allowAdd: '<',
        categoryId: '<',
        searchAllBrands: '<',
        model: '=',
        singleSelect: '<',
        onChange: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/brands/components/brandsSelector/brandsSelector.component.ts